module.exports = __webpack_public_path__ + "img/more2.dc02a6fc.png";